module.exports = __webpack_public_path__ + "static/media/ttm.1d47d9a4.png";